module.exports = __webpack_public_path__ + "media/images/individual-bbd7b85abce48c8046621faa9e8461d7.png";